<agm-map (mapReady)="this.mapReady($event)" [latitude]="currentLocation.latitude" [longitude]="currentLocation.longitude" [zoom]="this.zoom" [styles]="this.styleMap" >
</agm-map>